{
  "daytime": {
    "earlier": "Más pronto",
    "later": "Más tarde"
  },
  "login": {
    "title": "Iniciar sesión",
    "text": "Iniciar sesión en tu cuenta",
    "button": "Iniciar sesión",
    "stressLevel": "Nivel de estrés",
    "errorDialog": {
      "message": "Usuario o contraseña incorrectas",
      "accept": "De acuerdo"
    },
    "placeholder": {
      "username": "Por favor,  introduce tu nombre de usuario",
      "password": "Por favor, introduce tu contraseña"
    }
  },
  "sidebar": {
    "bulletins": "Avalanche.report",
    "dangerSources": "Fuentes de peligro",
    "observations": "Observaciones",
    "incidents": "Incidentes",
    "qfa": "FAQ",
    "modelling": "Modelización",
    "modellingForecast": "Previsión",
    "modellingZamg": "ZAMG multi modelo",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "Meteograma GeoSphere",
    "modellingSnowpack": "modelo SNOWPACK",
    "modellingSnowpackMeteo": "SNOWPACK modelled meteo",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "lineaexport": "LINEA",
    "awsstats": "AWS Stats",
    "yearlystats": "Yearly Stats",
    "graphics": "Graphics",
    "icon": "Tiempo atmosférico"
  },
  "weather": {
    "loading": "Loading weather parameters and images...",
    "noPng": "Image not found.",
    "error": {
      "noParameters": "No forecast parameters available.",
      "loadFailed": "Could not load forecast data."
    },
    "headings": {
      "model": "Model",
      "modelRun": "Model run",
      "region": "Región",
      "parameters": "Parameters",
      "level": "Level"
    },
    "alt": {
      "fallback": "Forecast map",
      "image": "{{model}} {{parameter}}{{level}} {{region}} {{date}} {{hour}}Z"
    },
    "models": {
      "icon": "ICON",
      "gfs": "GFS"
    },
    "regions": {
      "atlantic": "Atlantic",
      "europe": "Europe",
      "alps": "Alps",
      "euregio": "EUREGIO"
    },
    "levels": {
      "surface": "Surface",
      "cloudTotal": "Total",
      "cloudHigh": "High",
      "cloudMid": "Mid",
      "cloudLow": "Low"
    },
    "tooltips": {
      "levelApproxElevation": "Approx. elevation: ~{{height}} m"
    },
    "parameters": {
      "gfs": {
        "equivalentPotentialTemp": "Equivalent Potential Temp.",
        "relativeHumidity": "Relative Humidity",
        "geopotentialAndIsotachs": "Geopotential and Isotachs",
        "precipitation": "Precipitation",
        "cape": "CAPE"
      },
      "icon": {
        "cloudCover": "Cloud Cover",
        "ns": "Precipitation 1h",
        "ns24": "Precipitation 24h",
        "nsacc": "Acc. Precipitation",
        "nsprob24gt20": "Prob. Prec. > 20 mm / 24h",
        "nsprob24gt40": "Prob. Prec. > 40 mm / 24h",
        "nsprob24gt80": "Prob. Prec. > 80 mm / 24h",
        "d2m": "Dew Point 2m",
        "gust": "Max. Wind Gust 10m",
        "cape": "MU-CAPE"
      }
    }
  },
  "menu": {
    "logout": "Cerrar sesión",
    "language": "Idioma",
    "en": "Inglés",
    "de": "Alemán",
    "fr": "Francés",
    "it": "Italiano",
    "es": "Español",
    "ca": "Catalán",
    "oc": "Aranés",
    "fullscreen": "Pantalla completa",
    "settings": "Ajustes",
    "statistics": "Estadisticas",
    "admin": "Admin",
    "region": "Región",
    "education": "Educación"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Estabilidad del manto nivoso",
      "frequency": "Frecuencia",
      "avalancheSize": "Tamaño de alud",
      "dangerRating": "Clasificación del peligro",
      "override": "(modificar grado de peligro)",
      "matrix": "Matriz",
      "referToFairStability": "Referirse a estabilidad regular",
      "referToPoorStability": "Referirse a estabilidad pobre",
      "dangerLevel1": "Grado de peligro 1 (Débil)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "ausente",
      "available": "disponible",
      "forecast": "previsión",
      "analysis": "análisis",
      "loading": "Cargando fuentes de peligro",
      "saveError": "¡No se pudo guardar la fuente de peligro! ",
      "loadDangerSourcesError": "¡No se han podido cargar las fuentes de peligro!",
      "loadVariantsError": "¡No se han podido cargar las variantes de fuentes de peligro!",
      "noTitle": "<no title>"
    },
    "variantStatus": {
      "active": "activo",
      "dormant": "latente",
      "inactive": "inactivo"
    },
    "tooltip": {
      "read": "Leer las fuentes de peligro",
      "edit": "Editar las fuentes de peligro"
    },
    "table": {
      "loadMore": "Cargar {{count}} más días",
      "title": {
        "forecast": "Previsión",
        "analysis": "Análisis"
      }
    },
    "create": {
      "variantStatus": "Estado",
      "variantEditable": "Esta variante puede ser editada.",
      "variantNotEditable": "Esta variante no puede ser editada.",
      "noVariantsForSelectedDay": "No hay variantes definidas para esta fecha.",
      "tooltip": {
        "editDangerSource": "Editar la fuente de peligro",
        "loadVariants": "Cargar variantes del día anterior",
        "loadVariantsFromForecast": "Load variants from forecast",
        "showVariantsOnMap": "Mostrar variantes al mapa",
        "edit": "Editar micro-regiones",
        "copy": "Copiar variante",
        "delete": "Borrar variante",
        "compare": "Comparar variante",
        "forecast": "Comparar con la previsión"
      },
      "createDangerSource": "Crear fuente de peligro",
      "createVariant": "Crear nueva variante",
      "noDangerSources": "No hay fuentes de peligro",
      "title": {
        "slab": "Placa",
        "weakLayer": "Capa débil",
        "loose": "Nieve suelta",
        "glide": "Deslizamiento de nieve",
        "matrix": "Matriz",
        "characteristics": "Características",
        "comment": "Comentario",
        "uncertainties": "Incertidumbres"
      },
      "label": {
        "glidingSnowActivity": "Actividad de deslizamiento de nieve",
        "snowHeight": "Altura de la nieve",
        "snowHeightLowerLimit": "Min snow height",
        "snowHeightUpperLimit": "Max snow height",
        "snowHeightAverage": "Altura de la nieve promedio",
        "zeroDegreeIsotherm": "Isoterma de 0 °C",
        "looseSnowMoisture": "Humedad de la nieve suelta",
        "looseSnowGrainShape": "Forma de grano de la nieve suelta",
        "slabGrainShape": "Forma de grano de la placa",
        "slabThickness": "Espesor de la placa",
        "slabThicknessLowerLimit": "Min slab thickness",
        "slabThicknessUpperLimit": "Max slab thickness",
        "slabHandHardness": "Dureza de mano de la placa",
        "slabHandHardnessLowerLimit": "Min slab hand hardness",
        "slabHandHardnessUpperLimit": "Max slab hand hardness",
        "slabHardnessProfile": "Dureza de la placa",
        "slabEnergyTransferPotential": "Potencial de transferencia de energía de la placa",
        "slabDistribution": "Distribución de la placa",
        "weakLayerGrainShape": "Forma de grano de la capa débil",
        "weakLayerGrainShapes": "Weak layer grain shapes",
        "weakLayerGrainSize": "Tamaño de grano de la capa débil",
        "weakLayerGrainSizeLowerLimit": "Min weak layer grain size",
        "weakLayerGrainSizeUpperLimit": "Max weak layer grain size",
        "weakLayerPersistent": "Capa débil persistente",
        "weakLayerThickness": "Espesor de la capa débil",
        "weakLayerStrength": "Resistencia de la capa débil",
        "weakLayerWet": "Humedad de la capa débil",
        "weakLayerCrustAbove": "Costra encima de la capa débil",
        "weakLayerCrustBelow": "Costra debajo de la capa débil",
        "weakLayerPosition": "Posición de la capa débil",
        "weakLayerCreation": "Creación de la capa débil",
        "weakLayerDistribution": "Distribución de la capa débil",
        "dangerSpotRecognizability": "Reconocibilidad del lugar peligroso",
        "remoteTriggering": "Desencadenamiento a distancia",
        "hasDaytimeDependency": "Dependencia diurna",
        "dangerIncreaseWithElevation": "Aumento del peligro con la altitud",
        "runoutIntoGreen": "Zona de llegada hacia el verde",
        "penetrateDeepLayers": "Penetrar capas profundas",
        "highestDangerAspect": "Orientación con el peligro más alto",
        "dangerPeak": "Pico de peligro",
        "slopeGradient": "Gradiente de pendiente",
        "naturalRelease": "Desencadenamiento natural",
        "terrainTypes": "Tipos de terreno",
        "dangerSigns": "Signos de peligro",
        "aspects": "Orientaciones"
      },
      "createDangerSourceDialog": {
        "title": "Título",
        "description": "Descripción",
        "save": "Guardar",
        "cancel": "Cancelar"
      },
      "editDangerSourceDialog": {
        "title": "Título",
        "description": "Descripción",
        "update": "Actualización",
        "cancel": "Cancelar"
      },
      "deleteVariantDialog": {
        "message": "¿Quieres borrar esta variante?",
        "accept": "Si",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "Al menos una microrregión debe ser tuya",
        "accept": "De acuerdo"
      },
      "discardDialog": {
        "message": "¿Quieres descartar los cambios?",
        "accept": "Si",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "¡Se ha producido un error guardando las fuentes de peligro!",
        "accept": "De acuerdo"
      },
      "loadDialog": {
        "message": "Do you want to load all danger source variants from the day before?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Si",
        "reject": "No"
      },
      "loadFromForecastDialog": {
        "message": "Do you want to load all variants from the forecast?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Si",
        "reject": "No"
      }
    }
  },
  "avalancheType": {
    "title": "Tipo de alud",
    "slab": "slab",
    "loose": "loose",
    "glide": "glide",
    "cornice": "cornisa",
    "unknown": "desconocido",
    "label": {
      "slab": "PLACA",
      "loose": "SIN COHESIÓN",
      "glide": "DESLIZAMIENTO"
    },
    "tooltip": {
      "slab": "Alud de placa",
      "loose": "Alud de nieve sin cohesión",
      "glide": "Alud de deslizamiento de nieve"
    }
  },
  "elevation": {
    "title": "Altitud",
    "high": "Debajo",
    "low": "Encima",
    "treeline": "Límite superior del bosque"
  },
  "bulletins": {
    "title": "Avalanche.report",
    "tooltip": {
      "edit": "Editar boletín",
      "read": "Leer boletín",
      "copy": "Copiar boletín",
      "paste": "Pegar boletín",
      "cancel": "Cancelar copia",
      "update": "Editar",
      "submit": "Enviar",
      "submitUpdate": "Enviar actualización",
      "publishChange": "Publicar ahora (sin mensajes)",
      "publishUpdate": "Publicar ahora",
      "publishMinimal": "Minimal publication",
      "caaml": "Muestra CAAML",
      "json": "Muestra JSON",
      "create": "Crear boletín",
      "preview": "Vista previa del boletín (PDF)",
      "check": "Comprobar boletín",
      "info": "Muestra estado de la publicación",
      "loadSuggestionFromDangerSources": "Load suggestion from danger sources",
      "deleteAllWarningRegions": "Borrar todas las regiones de alerta",
      "publishAll": "Publicar todas las regiones",
      "publishAllNoMessages": "Publicar todas las regiones (sin mensajes)",
      "mediaFile": "Subir archivo multimedia",
      "publicationChecklist": "Open publication checklist"
    },
    "publicationChecklist": {
      "title": "Publication checklist",
      "description": {
        "website": "The map on the website shows the danger levels with their corresponding colors. Clicking on a region shows the avalanche problems and texts.",
        "email": "An email was sent and contains a report.",
        "telegram": "A message containing a link to the website was posted.",
        "whatsapp": "A message containing a link to the website was posted."
      },
      "ok": "De acuerdo",
      "problem": "Problem",
      "problemDescription": "Problem description",
      "problemPlaceholder": "Describe the encountered problem",
      "channel": {
        "website": "Website",
        "whatsapp": "WhatsApp",
        "telegram": "Telegram",
        "email": "Email"
      },
      "publicationInProgress": "Publication in progress",
      "publicationFinishedOnServer": "Finished publication on server",
      "publishDisabled": {
        "inProgress": "Publication is currently in progress.",
        "wrongStatus": "The bulletin must be submitted or published."
      },
      "emailWaitHint": "Email delivery usually takes longer than social media messages. At least 5 minutes should have passed since publication before you proceed to the next step.",
      "email": {
        "waitTitle": "Wait:"
      },
      "options": "Options",
      "republish": "Republish:",
      "resend": "Resend:",
      "website": {
        "checkInternetTitle": "Check internet connection:",
        "checkInternetDescriptionPrefix": "How is the internet connection on your device? Open",
        "checkInternetDescriptionSuffix": "in a private window. Is yesterday's bulletin displayed correctly?",
        "republishHint": "Only perform this step if “Check internet connection” was successful and at least 5 minutes have passed since the last publication attempt.",
        "publishMinimalTitle": "Minimal publication:",
        "publishMinimalHint": "Use this as a fallback if the full publication fails. Publishes CAAML data only — no maps, text-to-speech, or push messages. ⚠️ Also affects other regions on this server, not just your own. All will be republished in minimal mode.",
        "editAndResendTitle": "Edit and resend:",
        "openBulletin": "Open the bulletin",
        "clickEdit": "Click “Edit”",
        "clickSubmit": "Click “Submit”",
        "clickPublishNow": "Click “Publish now”"
      },
      "manualSend": {
        "title": "Manual send:",
        "description": {
          "telegram": "Copy the text below and send it to the specified Telegram group.",
          "whatsapp": "Copy the text below to the specified WhatsApp channel."
        },
        "copyText": "Copy {{language}} {{channel}} text"
      },
      "newChecklist": "New checklist",
      "savedInfo": "Saved by {{user}}, {{time}}",
      "print": {
        "contact": {
          "title": "Emergency contact",
          "emailLabel": "Email:",
          "nameLabel": "Name:",
          "phoneLabel": "Phone:"
        },
        "emergencyTitle": "If serious problems occur",
        "fallback": {
          "title": "Use fallback instance:",
          "step1": "Navigate to the fallback Admin-GUI and publish the bulletin there.",
          "step2": "Manually send messages to subscribed channels. Use the text below:",
          "step3": "Inform the public by creating social media posts linking to the fallback website URL.",
          "step4": "Inform the PR department about the situation."
        },
        "hide": "Hide print version",
        "hint": "Fill in the hosting service contact details and the fallback URLs below, then click \"Print\".",
        "hostingDescription": "Ask about server status. If applicable, request a server restart.",
        "hostingTitle": "Contact hosting service:",
        "print": "Print",
        "toggle": "Print version"
      }
    },
    "status": {
      "submittedInfo": "Será publicado a las 5PM",
      "resubmittedInfo": "Será publicado a las 8AM",
      "publishedInfo": "Ha sido publicado",
      "noPublicationInfo": "NO será publicado automàticamente",
      "loadingPreview": "Creando vista previa en PDF ...",
      "loading": "Cargando boletín ...",
      "loadMoreBulletins": "Cargar {{count}} más boletines",
      "publishing": "Publicando boletín ...",
      "submitting": "Enviando boletín ...",
      "saveError": "¡No se pudo guardar el boletín!",
      "loadBulletinsError": "¡No se han podido cargar los boletines!"
    },
    "create": {
      "tooltip": {
        "edit": "Editar micro-regiones",
        "copy": "Copiar región",
        "delete": "Borrar región",
        "deleteProblem": "Borrar problema",
        "compare": "Comparar región",
        "undo": "Deshacer el último cambio en la región",
        "redo": "Volver a hacer el cambio en la región",
        "createRegion": "Crear región",
        "cancel": "Cancelar",
        "acceptSuggestion": "Aceptar la región sugerida",
        "rejectSuggestion": "Rechazar la región sugerida",
        "saveChanges": "Guardar los cambios",
        "discardChanges": "Descartar los cambios",
        "incompleteAvalancheProblem": "Problema de aludes incompleto",
        "saveBulletin": "Guardar el boletín",
        "discardBulletin": "Descartar los cambios del boletín",
        "loadBulletin": "Cargar el boletín del día anterior",
        "uploadCaamlBulletin": "Upload bulletin in CAAML format",
        "uploadJsonBulletin": "Subir el boletín en formato JSON",
        "downloadCaamlBulletin": "Download bulletin in CAAML format",
        "downloadJsonBulletin": "Descargar el boletín en formato JSON",
        "daytimeDependency": "Dependencia diurna",
        "treeline": "Límite superior del bosque",
        "tendency": {
          "decreasing": "El peligro de aludes desciende",
          "steady": "El peligro de aludes se mantiene igual",
          "increasing": "El peligro de aludes aumenta",
          "danger": "Peligro de aludes"
        },
        "textcat": {
          "edit": "Editar",
          "copy": "Copiar",
          "paste": "Pegar",
          "example": "Cargar texto de ejemplo",
          "delete": "Borrar"
        },
        "moveUpAvalancheProblem": "Mover el problema de aludes hacia arriba",
        "moveDownAvalancheProblem": "Mover el problema de aludes hacia abajo",
        "dangerRatingDirectionUp": "Hacia arriba",
        "dangerRatingDirectionDown": "Hacia abajo",
        "addPhoto": "Add photo",
        "removePhoto": "Remove photo",
        "uploadPhoto": "Upload photo",
        "editPhoto": "Edit photo"
      },
      "save": "Guardar",
      "discard": "Descartar",
      "back": "Volver",
      "createAggregatedRegion": "Nueva región",
      "pasteAggregatedRegion": "Pegar región",
      "pendingSuggestions": "Sugerencias",
      "rejectSuggestion": "Rechazar",
      "acceptSuggestion": "Aceptar",
      "cancelCopyBulletin": " Cancelar",
      "createAvalancheProblem": "Nuevo problema",
      "ownRegions": "Regiones propias",
      "foreignRegions": "Regiones extranjeras",
      "externalRegions": "Regiones externas",
      "mapSelectRegion": "Seleccionar regiones en el mapa",
      "statusHeader": "Estado del boletín",
      "suggestions": "Sugerencias",
      "noBulletinsForSelectedDay": "Ninguna región definida para esta fecha",
      "autosave": "Guardado automáticamente",
      "regionEditable": "Esta región puede ser editada.",
      "regionNotEditable": "Esta región no puede editar-se.",
      "regionLocked": "Esta región está bloqueada.",
      "changeDangerRatingElevation": "Extender el peligro de aludes",
      "mapTop": "Mapa arriba",
      "mapLeft": "Mapa al lado",
      "showExternalRegions": "Mostrar regiones externas",
      "hideExternalRegions": "Ocultar regiones externas",
      "showNotes": "Mostrar notas",
      "hideNotes": "Ocultar notas",
      "incompleteAvalancheProblem": "Incompleto",
      "label": {
        "generalHeadlineComment": "Título general",
        "importantObservations": "Observaciones importantes",
        "avalancheProblems": "Problema de aludes",
        "aspects": "Orientaciones",
        "highlights": "Alerta especial",
        "avActivityHighlights": "Titular de la situación de aludes",
        "avActivityComment": "Descripción del peligro de aludes",
        "travelAdvisoryHighlights": "Headline travel advisory",
        "travelAdvisoryComment": "Description of travel advisory",
        "snowpackStructureHighlights": "Titular de la estructura del manto",
        "snowpackStructureComment": "Descripción de la estructura del manto",
        "dangerPatterns": "Patrón de peligro",
        "tendencyComment": "Descripción de la tendencia",
        "synopsisHighlights": "Headline weather synopsis",
        "synopsisComment": "Sinopsis del tiempo",
        "notes": "Notas",
        "noSnow": "Sin nieve"
      },
      "copyRegion": {
        "label": "Copiar región de alerta a otro boletín",
        "select": "Pegar en ...",
        "currentBulletin": "Este boletín"
      },
      "title": {
        "avalancheProblem": "Problemas de aludes",
        "dangerDescription": "Descripción del peligro de aludes",
        "forenoon": "Mañana",
        "afternoon": "Tarde",
        "photos": "Photos",
        "snowpackStructure": "Estructura del manto",
        "tendency": "Tendencia",
        "synopsis": "Tiempo atmosférico",
        "showTranslations": "Mostrar traducciones",
        "hideTranslations": "Ocultar traducciones"
      },
      "photos": {
        "url": "Image URL",
        "locationName": "Localización",
        "microregion": "Microregion",
        "copyright": "Copyright",
        "date": "Fecha"
      },
      "placeholder": {
        "notes": "Escribir aquí..."
      },
      "pmDialog": {
        "noIFrameSupport": "Tu navegador no soporta IFrames!"
      },
      "discardDialog": {
        "message": "¿Quieres descartar los cambios?",
        "accept": "Si",
        "reject": "No"
      },
      "deleteAggregatedRegionDialog": {
        "message": "¿Quieres borrar esta región?",
        "accept": "Si",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "Al menos una microrregión debe ser tuya",
        "accept": "De acuerdo"
      },
      "loadDialog": {
        "message": "Do you want to load the bulletins from the day before?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Si",
        "reject": "No"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "¿Quieres eliminar todas las regiones de alerta?",
        "accept": "Si",
        "reject": "No"
      },
      "loadSuggestionsFromDangerSourcesDialog": {
        "message": "Do you want to load suggestions from danger sources?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Si",
        "reject": "No"
      },
      "loadAutoSaveDialog": {
        "message": "¿Quieres cargar automáticamente los boletines guardados?",
        "accept": "Si",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "¡Se ha producido un error guardando los boletines!",
        "accept": "De acuerdo"
      },
      "changeErrorDialog": {
        "message": "Se ha producido un error cargando los boletines",
        "accept": "De acuerdo"
      },
      "loadingErrorDialog": {
        "message": "Se ha producido un error cargando los boletines",
        "accept": "De acuerdo"
      },
      "loadingJsonFileErrorDialog": {
        "message": "¡Hubo un error al cargar los boletines desde el archivo JSON!",
        "accept": "De acuerdo"
      },
      "avalancheProblemErrorDialog": {
        "message": "Falta el problema de alud, las orientaciones, la estabilidad del manto nivoso, la frecuencia y/o el tamaño de alud para al menos un problema de alud",
        "accept": "De acuerdo"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "¿Para que situación quieres cargar un texto de ejemplo?",
        "newSnow": "Nieve reciente",
        "windSlab": "Placas de viento",
        "persistentWeakLayers": "Capas débiles persistentes",
        "wetSnow": "Nieve húmeda",
        "glidingSnow": "Deslizamientos basales",
        "favourableSituation": "Situación favorable",
        "cancel": "Cancelar"
      },
      "removeDaytimeDependencyDialog": {
        "message": "¿Qué problemas de avalanchas quieres conservar?",
        "cancel": "Cancelar"
      },
      "strategicMindsetDialog": {
        "title": "Predisposiciones mentales estratégicas",
        "introduction": "Las \"Predisposiciones Mentales Estratégicas\" pretenden expresar nuestra actitud mental respecto a la situación de avalancha y su desarrollo en la zona de alerta correspondiente. No deben derivarse directamente de la evaluación del peligro, sino comprenderse y utilizarse como una impresión intuitiva de la situación general. Por lo tanto, las \"Predisposiciones Mentales Estratégicas\" son principalmente una herramienta de comunicación. Utilizando las predisposiciones mentales y las definiciones asociadas, los predictores podemos intercambiar información de forma rápida y eficiente sobre el desarrollo de la situación de peligro y encontrar un lenguaje común para la comunicación.",
        "description": {
          "title": "Descripción:",
          "text": {
            "assessment": "Existe una <b>gran incertidumbre</b> en la evaluación del peligro debido a la <b>información insuficiente</b> sobre el terreno.",
            "stepping_out": "<b>Tendencia decreciente</b> de la situación de peligro (también dentro de un nivel de peligro).",
            "status_quo": "Misma situación peligrosa. <b>Sin cambios significativos</b> en comparación con el día anterior.",
            "stepping_back": "<b>Tendencia creciente</b> de la situación de peligro (también dentro de un nivel de peligro).",
            "entrenchment": "<b>Situación peligrosa, casi constante y tensa.</b> El peligro principal proviene de (a) <b>capas débiles persistentes</b> (s) susceptibles a interferencias.",
            "free_ride": "<b> Peligro de avalanchas Débil</b> con el manto de nieve generalmente estable. Solo son posibles avalanchas pequeñas en terreno extremadamente inclinado.",
            "high_alert": "Situación excepcional con <b>peligro de avalanchas fuerte o muy fuerte</b>. Es posible que se produzcan avalanchas naturales de <b>magnitud muy grande o extrema</b>.",
            "spring_diurnal": "Las avalanchas de nieve húmeda que se producen a lo largo del día, sujetas a un <b>ciclo diurno claro</b>, son decisivas para la evaluación del riesgo."
          }
        },
        "communication": {
          "title": "Comunicación:",
          "text": {
            "assessment": "La situación de avalanchas debe evaluarse localmente. Se recomienda restricción.",
            "stepping_out": "Disminución gradual del peligro. Sin embargo, todavía se requiere precaución y se debe evaluar la mejora de la situación localmente antes de adentrarse en terrenos más arriesgado.  ",
            "status_quo": "La situación de peligro no ha cambiado. El feedback de los observadores ayuda a comprender mejor la situación de peligro. Se debe comunicar con mayor énfasis el terreno más favorable.",
            "stepping_back": "Comunicación clara del aumento del peligro de avalanchas, incluso dentro de un nivel de peligro. La información sobre las causas facilita la comprensión de la comunicación.",
            "entrenchment": "Se requiere precaución y restricción. La situación apenas cambia. De ser posible, proporcionar información lo más precisa posible sobre la distribución y la posibilidad de desencadenamiento. Se debe aumentar la comunicación de las observaciones que revelen la situación y muestran restricción.",
            "free_ride": "Texto breve. Destacar la situación general favorable y las zonas de peligro potencialmente aisladas.",
            "high_alert": "Comunicación a través de todos los canales. El enfoque ya no se centra en los deportes de invierno. Peligro incluso en zonas donde no suele haber riesgo de avalanchas.",
            "spring_diurnal": "Situación favorable por la mañana, que empeorará durante el día. La evaluación debe realizarse localmente observando el reblandecimiento de la costra de rehielo y la creciente humidificación del manto de nieve."
          }
        },
        "examples": {
          "title": "Ejemplos:",
          "text": {
            "assessment": "Inicio de la temporada.",
            "stepping_out": "El enfriamiento conduce a una disminución del riesgo de avalanchas de nieve húmeda después de un periodo de tiempo cálido y húmedo.",
            "status_quo": "Problema de placas de viento consistente con temperaturas frías, nieve suelta y viento.",
            "stepping_back": "La nevada reciente abundante provoca un aumento de la situación de peligro.",
            "entrenchment": "Problema crítico de capas débiles persistentes con potencial de avalanchas peligrosamente grandes. La situación se está estabilizando muy lentamente y requiere mucha restricción.",
            "free_ride": "Peligro de avalanchas débil, no hay capas débiles persistentes, todo el terreno ya está pisado.",
            "high_alert": "Nivel de peligro 4 o superior debido a grandes cantidades de nieve reciente y/o capas débiles persistentes y problemáticas.",
            "spring_diurnal": "Situación primaveral con tiempo seco, presión alta y temperaturas moderadas con un manto de nieve viejo mayoritariamente estable."
          }
        },
        "strategicMindset": {
          "assessment": "Alta incertidumbre",
          "stepping_out": "Mejorando",
          "status_quo": "Status Quo",
          "stepping_back": "Deteriorándose",
          "entrenchment": "Inestable persistente",
          "free_ride": "Favorable",
          "high_alert": "Alerta máxima",
          "spring_diurnal": "Primavera a lo largo del día"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-en.svg",
        "feedbackURL": "https://admin.avalanche.report/umfrage-entscheidungsbaum/en/",
        "decisionTree": "Árbol de decisión",
        "feedback": "Comentarios",
        "save": "Guardar",
        "discard": "Descartar"
      }
    },
    "table": {
      "title": {
        "date": "Fecha"
      },
      "status": {
        "missing": "ausente",
        "draft": "borrador",
        "submitted": "enviado",
        "published": "publicado",
        "updated": "actualizado",
        "resubmitted": "reenviado",
        "republished": "republicado"
      },
      "publishBulletinsDialog": {
        "message": "¿Quieres publicar el boletín?"
      },
      "publicationStatusDialog": {
        "headline": "Estado de publicación",
        "publishedBy": "Publicado por:",
        "publishedAt": "Publicado a las:",
        "validFor": "Válido para:",
        "title": {
          "prod": "Cosas serias",
          "test": "Sistema de prueba",
          "task": "Tarea",
          "language": {
            "all": "TODOS",
            "de": "DE",
            "it": "IT",
            "en": "EN"
          }
        },
        "email": {
          "label": "Correos electrónicos",
          "tooltip": "Enviar correos electrónicos",
          "success": "¡Correos electrónicos enviados exitosamente!",
          "error": "¡No se pudieron enviar los correos electrónicos!"
        },
        "telegram": {
          "label": "Mensajes de Telegram",
          "tooltip": "Enviar mensajes de Telegram",
          "success": "¡Mensajes de Telegram enviados exitosamente!",
          "error": "¡No se pudieron enviar los mensajes de Telegram!"
        },
        "whatsapp": {
          "label": "Mensajes de WhatsApp",
          "tooltip": "Enviar mensajes de WhatsApp",
          "success": "¡Mensajes de WhatsApp enviados exitosamente!",
          "error": "¡No se pudieron enviar los mensajes de WhatsApp!"
        },
        "push": {
          "label": "Notificaciones push",
          "tooltip": "Enviar notificaciones push",
          "success": "¡Notificaciones push enviadas exitosamente!",
          "error": "¡No se pudieron enviar notificaciones push!"
        },
        "accept": "De acuerdo",
        "confirm": "Do you want to send {{channel}} ({{language}})?"
      },
      "mediaFileDialog": {
        "headline": "Archivo multimedia",
        "important": "IMPORTANTE",
        "missingFile": "¡Ningún archivo seleccionado!",
        "uploadError": "¡Subida fallida!",
        "accept": "Enviar",
        "reject": "Cancelar"
      },
      "publishBulletinsErrorDialog": {
        "message": "¡Se ha producido un error publicando los boletines!",
        "accept": "De acuerdo"
      },
      "submitBulletinsDialog": {
        "message": "¿Quieres enviar el boletín?"
      },
      "submitBulletinsErrorDialog": {
        "message": "¡Se ha producido un error enviando los boletines!",
        "accept": "De acuerdo"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "¡Regiones establecidas varias veces! Los boletines no se pueden enviar.",
        "accept": "De acuerdo"
      },
      "checkBulletinsErrorDialog": {
        "message": "Se ha producido un error comprobando los boletines",
        "accept": "De acuerdo"
      },
      "previewErrorDialog": {
        "message": "¡No se pudo cargar la vista previa!",
        "accept": "De acuerdo"
      },
      "checkBulletinsDialog": {
        "message": "Comprobar boletín",
        "ok": "(todo bien)"
      },
      "publishAllDialog": {
        "message": "¿Quieres publicar todas las regiones?",
        "changeMessage": "¿Quieres publicar todas las regiones? (sin mensajes)"
      },
      "bulletinCheck": {
        "missingDangerRating": "Grado de peligro no establecido",
        "missingDangerRatingModificator": "Danger rating modificator not set",
        "missingRegion": "Regiones no establecidas",
        "duplicateRegion": "Regiones establecidas varias veces",
        "missingAvActivityHighlights": "Falta el titular de la situación de aludes",
        "missingAvActivityComment": "Falta la descripción del peligro de aludes",
        "missingSnowpackStructureHighlights": "Falta el titular de la estructura del manto",
        "missingSnowpackStructureComment": "Falta la descripción de la estructura del manto",
        "pendingSuggestions": "Sugerencias pendientes",
        "incompleteTranslation": "Traducción incompleta"
      }
    }
  },
  "training": {
    "training": "Entrenamiento",
    "timestamp": "Marca de tiempo de entrenamiento"
  },
  "admin": {
    "loadingStatistics": "Creando CSV ...",
    "server-configuration": {
      "title": "Servidor",
      "button": {
        "create": "Crear servidor",
        "save": "Guardar"
      },
      "table": {
        "name": "Nombre",
        "userName": "Nombre de usuario",
        "password": "Password",
        "publishAt5PM": "Publicar a las 5PM",
        "publishAt8AM": "Publicar a las 8PM",
        "pdfDirectory": "Directorio para PDF",
        "htmlDirectory": "Directorio para HTML",
        "serverImagesUrl": "Ruta de acceso al servidor de imágenes",
        "dangerLevelElevationDependency": "Dependencia de la altitud del nivel de peligro",
        "mapsPath": "Ruta de acceso a mapas",
        "mediaPath": "Ruta a los ficheros multimedia",
        "mapProductionUrl": "URL para producción de mapas",
        "apiUrl": "API URL"
      },
      "success": "Configuración guardada con éxito",
      "error": "No se puede guardar la configuración"
    },
    "region-configuration": {
      "title": "Región",
      "button": {
        "create": "Crear región",
        "save": "Guardar"
      },
      "table": {
        "general": {
          "title": "General"
        },
        "publication": {
          "title": "Publicación"
        },
        "components": {
          "title": "Componentes"
        },
        "configuration": {
          "title": "Configuración"
        },
        "languageConfiguration": {
          "title": "Configuración del idioma"
        }
      },
      "success": "Configuración guardada con éxito",
      "error": "No se puede guardar la configuración"
    },
    "users": {
      "title": "Usuarios",
      "button": {
        "create": "Crear usuario"
      },
      "tooltip": {
        "edit": "Editar usuario",
        "changePassword": "Canvia la contraseña",
        "delete": "Eliminar usuario"
      },
      "table": {
        "name": "Nombre",
        "email": "Email",
        "organization": "Organización",
        "regions": "Regiones",
        "roles": "Roles"
      },
      "deleteUserModalDialog": {
        "message": "¿Quieres eliminar al usuario?",
        "accept": "Si",
        "reject": "No"
      },
      "deleteUser": {
        "success": "Usuario eliminado",
        "error": "El usuario no pudo ser eliminado"
      },
      "createUser": {
        "success": "Usuario creado",
        "error": "No se pudo crear el usuario"
      },
      "updateUser": {
        "success": "Usuario guardado",
        "error": "No se ha podido guardar el usuario"
      }
    },
    "createUser": {
      "table": {
        "image": "Imagen",
        "name": "Nombre",
        "email": "Email",
        "organization": "Organización",
        "password": "Password",
        "password2": "Repetir password",
        "roles": "Roles",
        "regions": "Regiones"
      },
      "error": {
        "name": {
          "required": "Por favor ingrese un nombre"
        },
        "email": {
          "required": "Por favor introduzca una dirección de correo eléctronico",
          "invalid": "La dirección de correo electrónico es inválida"
        },
        "password": {
          "required": "Por favor introduzca un password",
          "length": "La contraseña debe tener al menos 8 caracteres",
          "mismatch": "Las contraseñas no coinciden"
        }
      },
      "button": {
        "create": "Crear usuario",
        "update": "Actualizar usuario",
        "cancel": "Cancelar"
      }
    },
    "observations": {
      "table": "Tabla",
      "map": "Mapa",
      "gallery": "Galería",
      "filters": "Flitros",
      "details": "Detalles",
      "title": "Observaciones",
      "newObservation": "Nueva observación",
      "exportObservations": "Exportar observaciones (GeoJSON)",
      "exportStatistics": "Exportar estadísticas (CSV)",
      "toggleFilterBar": "Mostrar/ocultar la barra de filtros",
      "button": {
        "submit": "Descargar"
      },
      "label": {
        "dateRange": "Periodo",
        "observer": "Observador"
      },
      "selectRegion": {
        "placeholder": "Región",
        "selectionLabel": "{0} región(es) seleccionadas"
      },
      "selectSources": {
        "placeholder": "Fuentes",
        "selectionLabel": "{0} fuente(s) seleccionadas"
      },
      "charts": {
        "charts": "Mapas",
        "nan": "Sin especificación",
        "reload": "Volver a cargar",
        "classify": "Classificar",
        "label": "Etiqueta",
        "invert": "Invertir",
        "reset": "Restablecer",
        "aspect": {
          "caption": "Orientación"
        },
        "elevation": {
          "caption": "Altitud"
        },
        "stability": {
          "caption": "Estabilidad"
        },
        "observationType": {
          "caption": "Tipo de observación"
        },
        "importantObservation": {
          "caption": "Importante"
        },
        "avalancheProblem": {
          "caption": "Problema de aludes"
        },
        "dangerPattern": {
          "caption": "Patrón de peligro"
        },
        "dangerSource": {
          "caption": "Fuente de peligro"
        },
        "days": {
          "caption": "Día"
        }
      }
    },
    "blog": {
      "title": "Blog",
      "language": {
        "title": "Idioma",
        "de": "DE",
        "it": "IT",
        "en": "EN"
      },
      "all": {
        "tooltip": "Enviar correos electrónicos, Telegram, WhatsApp y Push",
        "success": "¡Correo electrónico, Telegram, WhatsApp y Push enviados exitosamente!",
        "error": "¡No se pudieron enviar correos electrónicos, Telegram, WhatsApp y Push!"
      },
      "email": {
        "tooltip": "Enviar correos electrónicos",
        "success": "¡Correo electrónico enviado exitosamente!",
        "error": "¡No se pudo enviar el correo electrónico!"
      },
      "telegram": {
        "tooltip": "Enviar a través del canal de Telegram",
        "success": "¡Telegram enviado exitosamente!",
        "error": "¡No se pudo enviar el Telegram!"
      },
      "whatsapp": {
        "tooltip": "Enviar por canal de WhatsApp",
        "success": "¡WhatsApp enviado exitosamente!",
        "error": "¡No se pudo enviar el WhatsApp!"
      },
      "push": {
        "tooltip": "Enviar a través de notificaciones push",
        "success": "¡Push enviado exitosamente!",
        "error": "¡No se pudo enviar el push!"
      }
    }
  },
  "settings": {
    "title": "Ajustes",
    "effectiveRole": "Effective role",
    "effectiveRoleDefault": "All roles",
    "changePassword": {
      "title": "Cambiar la contraseña ",
      "oldPassword": {
        "label": "Contraseña actual ",
        "placeholder": "Contraseña actual "
      },
      "newPassword1": {
        "label": "Nueva contraseña",
        "placeholder": "Nueva contraseña"
      },
      "newPassword2": {
        "label": "Nuevo password (repetir)",
        "placeholder": "Nueva contraseña"
      },
      "submit": "Canvia la contraseña",
      "passwordChanged": "Contraseña cambiada con éxito",
      "passwordChangeError": "La contraseña no se ha podido cambiar",
      "passwordIncorrect": "Contraseña actual incorrecta",
      "error": {
        "oldPassword": {
          "required": "Por favor, introduce tu contraseña actual"
        },
        "newPassword": {
          "required": "Por favor, introduce una nueva contraseña",
          "mismatch": "Las contraseñas no coinciden"
        }
      }
    },
    "display": {
      "title": "Mostrar",
      "table": {
        "showCaaml": "Mostrar CAAML",
        "showJson": "MostrarJSON"
      }
    }
  },
  "statistics": {
    "title": "Estadisticas",
    "bulletins": "Boletines de aludes",
    "dangerSources": "Fuentes de peligro",
    "button": {
      "submit": "Descargar"
    },
    "label": {
      "dateRange": "Periodo",
      "extended": "Extensión",
      "duplicates": "Duplicados"
    },
    "error": {
      "downloadFailed": "The statistics export could not be downloaded. Please try again."
    }
  },
  "dangerRating": {
    "missing": "ausente",
    "noRating": "Sin clasificar",
    "no_rating": "Sin clasificar",
    "no_snow": "no snow",
    "low": "débil",
    "moderate": "limitado",
    "considerable": "notable",
    "high": "fuerte",
    "very_high": "muy fuerte",
    "veryHigh": "muy fuerte"
  },
  "avalancheProblem": {
    "newSnow": "Nieve reciente",
    "new_snow": "Nieve reciente",
    "windSlab": "Placas de viento",
    "wind_slab": "Placas de viento",
    "persistentWeakLayers": "Capas débiles persistentes",
    "persistent_weak_layers": "Capas débiles persistentes",
    "wetSnow": "Nieve húmeda",
    "wet_snow": "Nieve húmeda",
    "glidingSnow": "Deslizamientos basales",
    "gliding_snow": "Deslizamientos basales",
    "cornices": "Cornisas",
    "noDistinctAvalancheProblem": "Ningún problema de aludes evidente",
    "no_distinct_avalanche_problem": "Ningún problema de aludes evidente",
    "favourableSituation": "Situación favorable",
    "favourable_situation": "Situación favorable"
  },
  "dangerPattern": {
    "dp1": "pp.1: capas débiles persistentes",
    "dp2": "pp.2: avalanchas de fondo",
    "dp3": "pp.3: lluvia",
    "dp4": "pp.4: frío sobre cálido / cálido sobre frío",
    "dp5": "pp.5: nevada reciente después de un largo periodo cálido",
    "dp6": "pp.6: frío, nieve suelta y viento",
    "dp7": "dp.7: manto de nieve poco profundo junto a manto de nieve profundo",
    "dp8": "pp.8: escarcha de superfície enterrada",
    "dp9": "pp.9: nieve redonda enterrada",
    "dp10": "pp.10: escenario de primavera"
  },
  "strategicMindset": {
    "title": "Predisposición mental estratégica",
    "assessment": "Alta incertidumbre",
    "stepping_out": "Mejorando",
    "status_quo": "Status Quo",
    "stepping_back": "Deteriorándose",
    "entrenchment": "Inestable persistente",
    "free_ride": "Favorable",
    "high_alert": "Alerta máxima",
    "spring_diurnal": "Spring Diurnal"
  },
  "observationType": {
    "DrySnowfallLevel": "Nivel de nevada seca",
    "TimeSeries": "Series temporales",
    "Incident": "Incidente",
    "Profile": "Perfil de nieve",
    "Closure": "Cierre",
    "Blasting": "Voladura",
    "Avalanche": "Alud",
    "Evaluation": "Evaluación",
    "SimpleObservation": "Observación simple",
    "Webcam": "Webcam"
  },
  "importantObservation": {
    "ForBlog": "Para el blog",
    "SurfaceHoar": "Escarcha de superfície",
    "Graupel": "Nieve granulada",
    "StabilityTest": "Test de estabilidad",
    "IceFormation": "Formación de hielo",
    "VeryLightNewSnow": "Nieve reciente muy ligera"
  },
  "elevationTolerance": {
    "exact": "exacto",
    "50m": "±50m",
    "100m": "±100m",
    "200": "±200m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Límite de nieve seca para todo el evento de precipitación",
    "observationPeriod": "Límite de nieve seca en el momento de la observación"
  },
  "aspect": {
    "N": "N",
    "NE": "NE",
    "E": "E",
    "SE": "SE",
    "S": "S",
    "SW": "SW",
    "W": "W",
    "NW": "NW"
  },
  "role": {
    "SUPERADMIN": "Super Administrador",
    "ADMIN": "Administrador",
    "FORECASTER": "Predictor",
    "FOREMAN": "Jefe",
    "OBSERVER": "Observador"
  },
  "tendency": {
    "decreasing": "El peligro de aludes desciende",
    "steady": "El peligro de aludes se mantiene igual",
    "increasing": "El peligro de aludes aumenta"
  },
  "snowpackStability": {
    "unknown": "desconocido",
    "good": "buena",
    "fair": "regular",
    "poor": "pobre",
    "very_poor": "muy pobre"
  },
  "frequency": {
    "none": "(casi) ninguno",
    "few": "unos pocos",
    "some": "algunos",
    "many": "muchos"
  },
  "avalancheSize": {
    "small": "pequeña",
    "medium": "mediana",
    "large": "grande",
    "very_large": "muy grande",
    "extreme": "extremadamente grande"
  },
  "complexity": {
    "easy": "Fácil",
    "challenging": "Exigente",
    "complex": "Complejo"
  },
  "glidingSnowActivity": {
    "low": "débil",
    "medium": "mediana",
    "high": "fuerte"
  },
  "wetness": {
    "dry": "seca",
    "moist": "húmeda",
    "wet": "muy húmeda"
  },
  "characteristic": {
    "low": "débil",
    "medium": "mediana",
    "high": "fuerte",
    "very_high": "muy fuerte"
  },
  "thickness": {
    "thin": "degaldo",
    "thick": "grueso"
  },
  "snowpackPosition": {
    "upper": "superior",
    "middle": "medio",
    "lower": "inferior",
    "ground": "tierra"
  },
  "weakLayerCrust": {
    "no": "no",
    "partly": "parcialmente",
    "yes": "sí"
  },
  "creationProcess": {
    "radiation_recrystallization": "radiación",
    "diurnal_recrystallization": "diürno",
    "melt_layer_recrystallization": "capa de fusión",
    "surface_hoar_formation": "escarcha de superficie"
  },
  "recognizability": {
    "very_easy": "muy fácil",
    "easy": "fácil",
    "hard": "difícil",
    "very_hard": "muy difícil"
  },
  "distribution": {
    "isolated": "aislado",
    "specific": "específico",
    "widespread": "generalizado"
  },
  "probability": {
    "likely": "probable",
    "possible": "possible",
    "unlikely": "poco probable"
  },
  "detailedDaytime": {
    "evening": "anochecer",
    "first_night_half": "la primera parte de la noche",
    "second_night_half": "la segunda parte de la noche",
    "morning": "mañana",
    "forenoon": "mañana",
    "afternoon": "tarde"
  },
  "slopeGradient": {
    "moderately_steep": "moderadamente empinado",
    "steep": "empinado",
    "very_steep": "muy empinado",
    "extremely_steep": "extremadamente empinado"
  },
  "handHardness": {
    "fist": "P",
    "four_fingers": "4D",
    "one_finger": "1D",
    "pencil": "L",
    "knife": "C",
    "ice": "H"
  },
  "hardnessTendency": {
    "decreasing": "más blando abajo",
    "steady": "uniforme",
    "increasing": "más blando encima"
  },
  "terrainType": {
    "gullies_and_bowls": "canales y cubetas",
    "adjacent_to_ridgelines": "adyacente a crestas",
    "distant_from_ridgelines": "lejano a las crestas",
    "in_the_vicinity_of_peaks": "cerca de las cimas",
    "pass_areas": "cerca de collados",
    "shady_slopes": "laderas umbrías",
    "sunny_slopes": "laderas solanas",
    "grassy_slopes": "laderas herbosas",
    "cut_slopes": "taludes",
    "wind_loaded_slopes": "laderas con placas de viento",
    "base_of_rock_walls": "base de paredes de roca",
    "behind_abrupt_changes_in_the_terrain": "detrás de cambios abruptos en el terreno",
    "transitions_into_gullies_and_bowls": "transiciones hacia canales y cubetas",
    "areas_where_the_snow_cover_is_rather_shallow": "zonas donde el manto de nieve es bastante superficial",
    "transitions_from_a_shallow_to_a_deep_snowpack": "transiciones de manto de nieve delgado a profundo",
    "highly_frequented_off_piste_terrain": "terreno fuera-pista muy frecuentado",
    "little_used_backcountry_terrain": "terreno de montaña poco utilizado",
    "places_that_are_protected_from_the_wind": "lugares protegidos del viento",
    "regions_exposed_to_the_foehn_wind": "regiones expuestas al viento foehn",
    "regions_with_a_lot_of_snow": "regiones con mucha nieve",
    "regions_exposed_to_precipitation": "regiones expuestas a la precipitación",
    "regions_exposed_to_heavier_precipitation": "regiones expuestas a precipitación abundante"
  },
  "dangerSign": {
    "shooting_cracks": "fisuras con propagación",
    "whumpfing": "whumpfing",
    "fresh_avalanches": "avalanchas recientes",
    "glide_cracks": "grietas de deslizamiento"
  },
  "changeRegionDialog": {
    "message": "¿Quieres cambiar la región?",
    "accept": "Si",
    "reject": "No"
  },
  "zamg": {
    "table": "Tabla",
    "map": "Mapa",
    "region": "Región",
    "newSnow": "Nieve reciente"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "nieve húmeda: contenido de agua líquida",
      "wet_snow_instability": "nieve húmeda: inestabilidad de nieve húmeda ",
      "Sk38_stratigraphy": "capas débiles persistentes: índice de estabilidad SK38",
      "stratigraphy": "capas débiles persistentes: estratigrafia de la nieve"
    },
    "aspect": {
      "flat": "llano",
      "north": "norte",
      "south": "sur"
    },
    "meteo": {
      "new_snow_plot_3day": "nieve reciente (3d)",
      "new_snow_plot_7day": "nieve reciente (7d)",
      "new_snow_plot_1month": "nieve reciente (31d)",
      "new_snow_plot_season": "nieve reciente (temporada)",
      "new_snow_plot_forecast": "nieve reciente (predicción)",
      "wet_snow_plot_3day": "nieve húmeda (3d)",
      "wet_snow_plot_7day": "nieve húmeda (7d)",
      "wet_snow_plot_1month": "nieve húmeda (31d)",
      "wet_snow_plot_season": "nieve húmeda (temporada)",
      "wet_snow_plot_forecast": "nieve húmeda (predicción)",
      "HS_table_24h": "tabla altura de nieve (1d)",
      "HS_table_72h": "tabla altura de nieve (3d)",
      "HS_table_season": "tabla altura de nieve (temporada)",
      "HS_table_forecast": "tabla altura de nieve (predicción)",
      "TA_table_24h": "tabla temperatura (1d)",
      "TA_table_72h": "tabla temperatura (3d)",
      "TA_table_season": "tabla temperatura (temporada)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "Partículas de precipitación"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "Nieve granulada"
    },
    "DF": {
      "code": "DF",
      "class": "Partículas de precipitación descompuestas y fragmentadas"
    },
    "RG": {
      "code": "RG",
      "class": "Granos finos"
    },
    "FC": {
      "code": "FC",
      "class": "Facetas"
    },
    "FCxr": {
      "code": "FCxr",
      "class": "Rounding Faceted Crystals"
    },
    "DH": {
      "code": "DH",
      "class": "Escarcha de profundidad"
    },
    "SH": {
      "code": "SH",
      "class": "Escarcha de superfície"
    },
    "MF": {
      "code": "MF",
      "class": "Formas de fusión"
    },
    "MM": {
      "code": "MM",
      "class": "Machine Made"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "Costra de fusión-rehielo"
    },
    "IF": {
      "code": "IF",
      "class": "Formaciones de hielo"
    }
  },
  "button": {
    "true": "Si",
    "false": "No",
    "ok": "De acuerdo",
    "yes": "Si",
    "no": "No"
  },
  "observations": {
    "$externalURL": "External URL (e.g. to photo database)",
    "$type": "Observation type",
    "allowEdit": "Editar la observación externa",
    "allowEditTooltip": "Esto evitará sobrescrituras de {{ value }}",
    "editIconTooltip": "Observación editada: no recibe actualizaciones de {{ value }}",
    "aspect": "Orientación",
    "authorName": "Nombre del autor",
    "avalancheLength": "Longitud de alud",
    "avalancheProblem": "Problema de aludes",
    "avalancheProblems": "Avalanche problem",
    "avalancheSize": "Tamaño de alud",
    "avalancheType": "Tipo de alud",
    "avalancheWidth": "Ancho de alud",
    "search": "Busca",
    "count": "# observaciones:",
    "elevationTolerance": "Precisión de los datos de altura",
    "elevationPeriod": "Período de tiempo de la altitud",
    "layers": {
      "observers": "Observadores",
      "weatherStations": "Estaciones meteorológicas",
      "webcams": "Webcams",
      "observations": "Observaciones"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Nivel de nevada seca",
        "globalRadiation": "Radiación global",
        "newSnow": "Nieve reciente",
        "snowLine": "Límite de nieve",
        "snowHeight": "Altura de nieve",
        "snowDifference": "Diferencia de nieve",
        "airTemperature": "Temperatura del aire",
        "airTemperatureMax": "Temperatura del aire máx",
        "airTemperatureMin": "Temperatura del aire mín",
        "surfaceTemperature": "Temperatura de supeficie",
        "surfaceHoar": "Potencial de formación de escarcha de superficie",
        "surfaceHoarCalc": "Potencial de formación de escarcha de superficie (Lehning et. al.)",
        "dewPoint": "Temperatura del punto de rocío",
        "relativeHumidity": "Humedad relativa",
        "windDirection": "Dirección del viento",
        "windSpeed": "Velocidad del viento",
        "windGust": "Racha de viento"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "10min atrás",
        "minusOneHour": "1h atrás",
        "plusTenMinutes": "10min adelante",
        "plusOneHour": "1h adelante"
      }
    },
    "button": {
      "add": "Añadir observación",
      "save": "Guardar observación",
      "delete": "Eliminar observación",
      "deleteConfirm": "Eliminar observación?",
      "discard": "Descartar",
      "copyDate": "Copiar fecha del evento"
    },
    "comment": "Comentario",
    "content": "Contenido",
    "dangerPatterns": "Danger patterns",
    "dangerRating": "Clasificación del peligro",
    "dangerSource": "Fuente de peligro",
    "elevation": "Altitud",
    "elevationRange": "Rango de altitud",
    "elevationLowerBound": "Límite inferior de altitud",
    "elevationUpperBound": "Límite superior de altitud",
    "eventDate": "Fecha del evento",
    "eventType": "Tipo de evento",
    "eventTypes": {
      "IMPORTANT": "Evento importante",
      "NEIGHBOR_REGION": "Región vecina",
      "NORMAL": "Evento normal",
      "PERSON_DEAD": "Evento con personas implicadas (muertos)",
      "PERSON_INJURED": "Evento con personas implicadas (heridos)",
      "PERSON_NO": "Evento sin personas implicadas",
      "PERSON_UNINJURED": "Evento con personas implicadas (ilesos)",
      "PERSON_UNKNOWN": "Evento (desconocido)",
      "TRAFFIC": "Tránsito"
    },
    "externalURL": "URL externa (por ejemplo, a una base de datos de fotografías)",
    "fractureDepth": "Profundiad de cicatriz",
    "hasCoordinates": "Tiene coordenadas",
    "incline": "Inclinación",
    "importantObservations": "Important observations",
    "latitude": "Laltitud",
    "locationName": "Localización",
    "longitude": "Longitud",
    "observationType": "Tipo de observación",
    "personInvolvement": "Implicación de personas",
    "reportDate": "Fecha del informe",
    "showTable": "Tabla",
    "stability": "Snowpack Stability",
    "withoutCoordinates": "Observaciones sin coordenadas:",
    "sidebar": {
      "filter": {
        "title": "Filtrar"
      },
      "legend": {
        "title": "Leyenda"
      },
      "sources": {
        "title": "Fuentes de datos"
      },
      "views": {
        "title": "Vistas"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Evento con personas implicadas (muertos)",
    "Injured": "Evento con personas implicadas (heridos)",
    "Yes": "Event involving persons",
    "No": "Evento sin personas implicadas",
    "Uninjured": "Evento con personas implicadas (ilesos)",
    "Unknown": "Evento (desconocido)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Día",
    "time": "Hora",
    "back": "Volver",
    "parameters": {
      "DUST": "Polvo del Sahara ",
      "N": "Cobertura total de nubes en /8",
      "Nh": "Cobertura total de nubes altas en /8",
      "Nm": "Cobertura total de nubes medias en /8",
      "Nl": "Cobertura total de nubes bajas en /8",
      "N-CU": "Cobertura total de cúmulos en /8",
      "AUSL.T": "temperatura de desencadenamiento",
      "SHW-IX": "Índice Showalter",
      "WX -CUF": "tiempo significativo: NIL (ninguno), RASH (lluvia), TS (tormenta eléctrica)",
      "RR": "Precipitación total [mm]",
      "RR-str": "precipitaciones estratiformes",
      "CONV": "Precipitación convectiva [mm]",
      "SN": "Precipitación en forma de nieve [mm]",
      "SN--RA": "cota de nieve [m]",
      "QAO ": "{{value}} hPa eq. viento promedio, dirección i velocidad, [°] and [m/s]",
      "QAN": "viento promedio al suelo, dirección y velocidad, [°] and [m/s]",
      "QANmax": "viento máx. (rachas) al suelo [m/s]",
      "T ": "{{value}} hPa eq. Temperatura [°C]",
      "T m": "Temperatura a {{value}}m [°C]",
      "T 2m": "Temperatura a 2m [°C]",
      "Tk 2m": "Temperatura a 2m [°K]",
      "T GND": "temperatura del suelo",
      "Max-ADI": "Temperatura máxima de mezcla [°C]",
      "Min Max": "temperatura mín./máx. en las últimas 24h",
      "FROST": "altura de la isozero [m]",
      "W cm": "500 hPa eq. viento vertical [cm/s]",
      "W --": "700 hPa eq. viento vertical [cm/s]",
      "W s": "{{value}} hPa eq. viento vertical [cm/s]",
      "H ": "{{value}} hPa altura geopotencial [m]",
      "RF ": "{{value}} hPa eq. humedad relativa [%]"
    }
  },
  "awsome": {
    "Aggregation band": "Banda de agregación",
    "Date": "Fecha",
    "Datetag": "Etiqueta de fecha",
    "Depth": "Profundidad",
    "Dry instability": "Inestabilidad de nieve seca",
    "fair (<0.77)": "regular (<0.77)",
    "fair (<1.05)": "regular (<1.05)",
    "Grain type": "Tipo de grano",
    "LWC index": "Índice LWC",
    "New snow": "Nieve reciente",
    "poor (<=3)": "pobre (<=3)",
    "poor (<0.95)": "pobre (<0.95)",
    "poor (>=0.77)": "pobre (>=0.77)",
    "Punstable": "Punstable",
    "rather stable (<0.7)": "bastante estable (<0.7)",
    "rather stable (<1)": "bastante estable (<1)",
    "rather stable (>1.05)": "bastante estable (>1.05)",
    "Size estimate": "Estimación de tamaño",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0.8)",
    "very poor (<=0.5)": "muy pobre (<=0.5)",
    "very poor (>3)": "muy pobre (>3)",
    "Wet instability": "Inestabilidad de nieve húmeda"
  },
  "channelStatus": {
    "loading": "Cargando el canal del estado de la información",
    "triggerStatusChecks": "Desencadenar comprovaciones de estado"
  },
  "lineaexport": {
    "searchfieldplaceholder": "Buscar estaciones...",
    "hint": "Presionar Enter para agregar"
  },
  "awsstats": {
    "title": "AWS statistics",
    "label": {
      "loading": "Loading data...",
      "startDate": "Start date",
      "endDate": "End date",
      "selectWeatherStation": "Select weather station",
      "selectMicroRegions": "Select micro-regions",
      "clearselection": "Clear selection",
      "noMicroRegionsSelected": "ninguno",
      "last7days": "Last 7 days",
      "last30days": "Last 30 days",
      "last90days": "Last 90 days",
      "loadData": "Load data",
      "charttypes": "Chart types"
    },
    "charts": {
      "aws-observations": "AWS observations",
      "aws-danger-rating": "Clasificación del peligro",
      "aws-danger-rating-altitude": "Danger rating by altitude",
      "aws-avalanche-activity-index": "Avalanche activity index",
      "aws-danger-rating-danger-source-variants": "Danger source variants",
      "aws-danger-source-variants-matrix-parameter-stability": "Danger source variants stability",
      "aws-danger-source-variants-matrix-parameter-frequency": "Danger source variants frequency",
      "aws-danger-source-variants-matrix-parameter-avalanche-size": "Danger source variants avalanche size"
    },
    "error": {
      "startDateBeforeEndDate": "Start date must be before or equal to end date.",
      "failedLoadData": "Failed to load data for selected date range.",
      "startDateEndDateRequired": "Start date and end date are required."
    }
  },
  "yearlystats": {
    "title": "Yearly Statistics",
    "label": {
      "startDate": "Start date",
      "endDate": "End date",
      "loaddata": "Load data",
      "last90Days": "Last 90 days",
      "last180Days": "Last 180 days",
      "currentSeason": "Current season",
      "regionCode": "Region code",
      "allRegions": "TODOS",
      "virtualTrainings": "Virtual trainings (dates)",
      "fieldTrainings": "Field trainings (dates)",
      "dangerRatingReference": "Danger rating reference"
    },
    "charts": {
      "aws-danger-rating-micro-regions-bars": "AWS Danger Rating - Micro Regions - Bars",
      "aws-danger-rating-micro-regions": "AWS Danger Rating - Micro Regions",
      "aws-danger-rating-distribution": "AWS Danger Rating - Distribution",
      "aws-danger-pattern-micro-regions": "AWS Danger Pattern - Micro Regions",
      "aws-avalanche-problem-micro-regions": "AWS Avalanche Problem - Micro Regions",
      "aws-products": "AWS Products",
      "aws-stress-level": "Team Stress Level"
    },
    "hint": {
      "dangerRatingReference": "Reference values for a danger rating distribution over different seasons, shown in grey",
      "dateChange": "After changing the date, the 'Load data' button must be pressed."
    }
  },
  "zodForm": {
    "valid": "Valid",
    "required": "Required",
    "invalidNumber": "Please enter a valid number."
  }
}
